<template>
  <of-dialog
    :title="formTitle"
    @onCancel="cancel"
    @onConfirm="confirm"
    :isConfirm="isConfirm"
    :width="width"
  >
    <div slot="content">
      <el-form
        label-width="120px"
        ref="form"
        :model="dataForm"
        :rules="editFormRules"
      >
        <el-form-item label="快递公司：" prop="ExpressCompany">
          <el-input
            placeholder="请输入快递公司"
            v-model="dataForm.ExpressCompany"
            clearable
            maxlength="100"
          ></el-input>
        </el-form-item>
        <el-form-item label="快递单号：" prop="ExpressNo">
          <el-input
            placeholder="请输入快递单号"
            v-model="dataForm.ExpressNo"
            clearable
            maxlength="100"
          ></el-input>
        </el-form-item>
        <el-form-item label="签收日期：" prop="ReceiveTime">
          <el-date-picker
            v-model="dataForm.ReceiveTime"
            type="date"
            value-format="timestamp"
            placeholder="选择签收日期"
          ></el-date-picker>
        </el-form-item>
      </el-form>
    </div>
  </of-dialog>
</template>
<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import api from "@/modules/zjrc/api";

export default {
  name: "receipt",
  props: {
    id: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      editFormRules: {
        ExpressCompany: {
          required: true,
          message: "快递公司不能为空",
          trigger: "blur",
        },
        ExpressNo: {
          required: true,
          message: "快递单号不能为空",
          trigger: "blur",
        },
        ReceiveTime: {
          required: true,
          message: "签收日期不能为空",
          trigger: "blur",
        },
      },
      formTitle: "确认收货",
      isConfirm: false,
      width: "35%",
      dataForm: {},
    };
  },
  components: {
    OfDialog,
  },
  methods: {
    //取消
    cancel() {
      this.$emit("formCallBack", null);
    },
    //提交
    confirm() {
      let that = this;
      that.$refs.form.validate((valid) => {
        if (valid) {
          that.isConfirm = true;
          let params = Object.assign({}, that.dataForm);
          params.Id = that.id;
          params.ReceiveTime = params.ReceiveTime / 1000;
          api
            .SaveSeekHelpApplyReceipt(params)
            .then((res) => {
              that.isConfirm = false;
              if (res.data.Code === 0) {
                this.$message({
                  message: "提交成功",
                  type: "success",
                });
                this.$emit("formCallBack", params);
              } else {
                this.$message({
                  message: res.data.Message,
                  type: "error",
                });
              }
            })
            .catch((e) => {
              this.isConfirm = false;
              this.$message({
                message: e.toString(),
                type: "error",
              });
            });
        }
      });
    },
  },
};
</script>